import gql from 'graphql-tag';
import { TAG_DETAILS_FRAGMENT } from './fragments';

const updateTagMutation = gql`
  mutation UpdateTag($input: UpdateTagInput!) {
    updateTag(input: $input) {
      ...TagDetails
    }
  }
  ${TAG_DETAILS_FRAGMENT}
`;

export default {
  mutation: updateTagMutation,
  module: 'tags',
  isSilent: true,
  buildVariables: ({ tagId, label, color }) => ({
    input: {
      tagId,
      ...(label !== undefined ? { label } : {}),
      ...(color !== undefined ? { color } : {})
    }
  })
};